import numbro from 'numbro';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { smartParentPlanPrices } from '../../../constants/exchangeRates';
import { SVGIconType } from '../../../constants/svgIcon';
import { useSessionStore } from '../../../stores/SessionStore';
import { useUserStore } from '../../../stores/UserStore';
import { getLocalCurrencyById } from '../../../utils/region';
import { SvgIcon } from '../../Molecules';
import { BasicPopupContainer } from '../Containers/BasicPopupContainer';

import styles from './SmartParentsReferralRewardsInfoPopup.module.css';

type SmartParentsReferralRewardsInfoPopupProps = {
  onPrimary: () => void;
};

export const SmartParentsReferralRewardsInfoPopup = (
  props: SmartParentsReferralRewardsInfoPopupProps,
) => {
  const { onPrimary } = props;

  const { t } = useTranslation();
  const activeRegion = useSessionStore((store) => store.activeRegion);

  const activeUserId = useSessionStore((store) => store.activeUserId);
  const userProfile = useUserStore((state) =>
    state.getProfile(activeUserId ?? ''),
  );
  const currency = useMemo(() => {
    return userProfile?.localCurrency ?? getLocalCurrencyById(activeRegion);
  }, [userProfile, activeRegion]);

  return (
    <BasicPopupContainer onPrimaryButtonClick={onPrimary}>
      <div className={styles.popupContent}>
        <SvgIcon
          name={SVGIconType.Referral}
          width={80}
          height={80}
          stroke="black"
        />
        <div className={styles.title}>{t('Referral Rewards')}</div>

        <div className={styles.infoBox}>
          <div className={styles.infoBoxTitle}>
            {t(
              'Rewards Per Purchases of JOYAJOY Smart Parents Plan from Referred Users',
            )}
          </div>

          <hr className={styles.divider} />

          <div className={styles.tier}>
            <p>{t('Tier 1 Referral Reward:')}</p>
            <p className={styles.infoBoxRewardItem}>
              {t('1st Year - ')}
              {currency}
              {numbro(
                smartParentPlanPrices[currency].tier1PurchaseReward,
              ).format({ thousandSeparated: true })}
            </p>
            <p className={styles.infoBoxRewardItem}>
              {t('Afterwards - ')}
              {currency}
              {numbro(
                smartParentPlanPrices[currency].tier1RepurchaseReward,
              ).format({ thousandSeparated: true })}
            </p>
            <p className={styles.caption}>{t('Your Referred Users')}</p>
          </div>

          <hr className={styles.divider} />

          <div className={styles.tier}>
            <p>{t('Tier 2 Referral Reward:')}</p>
            <p className={styles.infoBoxRewardItem}>
              {t('1st Year - ')}
              {currency}
              {numbro(
                smartParentPlanPrices[currency].tier2PurchaseReward,
              ).format({ thousandSeparated: true })}
            </p>
            <p className={styles.infoBoxRewardItem}>
              {t('Afterwards - ')}
              {currency}
              {numbro(
                smartParentPlanPrices[currency].tier2RepurchaseReward,
              ).format({ thousandSeparated: true })}
            </p>
            <p className={styles.caption}>
              {t('The Referred Users of Your Referred Users')}
            </p>
          </div>
        </div>
      </div>
    </BasicPopupContainer>
  );
};
